import { useParams } from 'react-router-dom';
import ROUTER from '../../../routers/Routers';
import ProductCard from '../../../components/homepage/ProductCard/ProductCard';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { fetchSaleProducts } from '../../../store/actions/sale-product.action';
import { Progress } from 'antd';
import ButtonSecondaryLarge from '../../../components/common/ButtonSecondary/ButtonSecondaryLarge';
import { useTranslation } from 'react-i18next';
import { Spin } from 'antd';
import Empty from '../../../components/common/Empty/Empty';
import { useNavigate } from 'react-router-dom';
import { reloadSaleProducts } from '../../../store/reducers/sale-product.reducer';
import { convertForeignCurrency } from '../../../utils/currency/currency.utils';

const SectionProductList = () => {
  const country_code = process.env.REACT_APP_COUNTRY_CODE ?? 'vn';
  const { id } = useParams();
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { saleProducts } = useSelector(state => state.saleProduct);

  const [searchParams, setSearchParams] = useSearchParams();
  const sizesParam = searchParams.get('size');
  const pricesParam = searchParams.get('price_range');
  const discountsParam = searchParams.get('discount');
  const modesParam = searchParams.get('sale_type');
  const kwParam = searchParams.get('kw') || '';
  const sortByParam = searchParams.get('sort');
  const offsetParam = searchParams.get('offset') ?? 0;
  const limitParam = searchParams.get('limit') ?? 10;

  const reloadData = useCallback(() => {
    dispatch(
      fetchSaleProducts({
        productId: id,
        size: sizesParam,
        price_range: pricesParam,
        discount: discountsParam,
        saleType: modesParam,
        kw: kwParam.trim()?.length ? kwParam.trim() : undefined,
        sort: sortByParam,
        offset: offsetParam,
        limit: limitParam,
        country_code,
      })
    );
  }, [
    id,
    sizesParam,
    pricesParam,
    discountsParam,
    modesParam,
    kwParam,
    sortByParam,
    offsetParam,
    limitParam,
    country_code,
  ]);

  useEffect(() => {
    if (id && saleProducts.data[id]?.isNeedReloadData) {
      reloadData();
    }
  }, [id, saleProducts.data[id]?.isNeedReloadData]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (id) {
        dispatch(reloadSaleProducts({ id }));
      }
    }, 500); // Đợi 500ms sau khi user ngừng gõ

    // Cleanup: Clear timer nếu user gõ tiếp
    return () => clearTimeout(timer);
  }, [
    id,
    sizesParam,
    pricesParam,
    discountsParam,
    modesParam,
    kwParam,
    sortByParam,
    offsetParam,
    limitParam,
  ]);

  return (
    <section className="flex flex-col lg:justify-start lg:items-start justify-center items-center gap-[24px] @container">
      <div className="justify-start items-start gap-[4px] grid xl:grid-cols-3 md:grid-cols-2 grid-cols-1">
        {saleProducts.data[id]?.products?.map(product => (
          <ProductCard
            onClick={() => {
              // if (item.type_design === 'sofa') {
              //   window.open(
              //     `https://www.lanhadecor.vn/san-pham/${product.name.toLowerCase()}/${product._id}`,
              //     '_blank'
              //   );
              // } else {
              // window.location.href = ROUTER.PRODUCT_DETAIL + '/' + product.id;
              navigate(ROUTER.PRODUCT_DETAIL + '/' + product.id);
              // }
            }}
            className={'lg:w-[313px] !w-full'}
            item={{
              ...product,
              priceAfter: product.price_after || 0,
              priceOriginal: product.price_original || 0,

              images: [
                ...(product.image_urls?.map(icon => ({ src: icon })) || []),
                ...(product.images?.map(icon => ({ src: icon })) || []),
              ],
            }}
            tags={
              product.discount_value
                ? [
                    {
                      label:
                        product.discount_type === 'PERCENT_DISCOUNT'
                          ? `${product.discount_value}%`
                          : `${convertForeignCurrency(product.discount_value)}`,
                      className:
                        'bg-primary-secondary py-[4px] px-[8px] rounded-[4px]',
                    },
                  ]
                : null
            }
          />
        ))}
      </div>
      {saleProducts.data[id]?.isLoading ? (
        <div className="flex p-[16px] flex-col items-center gap-[8px] self-stretch lg:w-[800px] w-full">
          <Spin spinning size={'large'} />
        </div>
      ) : saleProducts.data[id]?.products?.length ? (
        <div className="flex p-[16px] flex-col items-center gap-[8px] self-stretch">
          <span className="text-body-medium">
            {t('Show')} {saleProducts.data[id]?.products?.length || 0} {t('in')}{' '}
            {saleProducts.data[id]?.total || 0} {t('Products')}
          </span>
          <div className="w-[187px] flex items-center justify-center">
            <Progress
              percent={(() => {
                return (
                  ((saleProducts.data[id]?.products?.length || 0) /
                    (saleProducts.data[id]?.total || 1)) *
                  100
                );
              })()}
              showInfo={false}
              className="[&_.ant-progress-bg]:!bg-primary-primary"
            />
          </div>
          {Number(offsetParam) + Number(limitParam) <=
            (saleProducts.data[id]?.total || 0) && (
            <ButtonSecondaryLarge
              title={t('View More')}
              onClick={() => {
                const params = Object.fromEntries(searchParams);
                const newOffset = Number(offsetParam) + Number(limitParam);
                params['offset'] = newOffset;
                setSearchParams(params);
              }}
            />
          )}
        </div>
      ) : (
        <div className="flex p-[16px] flex-col items-center gap-[8px] self-stretch lg:w-[800px] w-full">
          <Empty imageStyle={{ width: '160px' }} />
        </div>
      )}
    </section>
  );
};

export default SectionProductList;
